const endpoint = process.env.REACT_APP_ENDPOINT || '';
const liffId = process.env.REACT_APP_LIFF_ID || '';
const channelId = process.env.REACT_APP_CHANNEL_ID || '';
const creatorsHome = process.env.REACT_APP_CREATORS_HOME_PAGE || '';

const adminTokenKey = 'adminToken';
const adminEmailKey = 'adminEmail';

export const constants = {
  endpoint,
  liffId,
  channelId,
  adminTokenKey,
  adminEmailKey,
  creatorsHome,
};
